import React from 'react'
import { FiStar, FiClock, FiUser, FiMessageSquare } from 'react-icons/fi';

function Instructors({ course }) {
   
   const instructorName = course.primary_instructor?.instructorName || "Floyd Miles";
   const instructorTitle = course.primary_instructor?.title || "President of Sales";
   const instructorBio = course.primary_instructor?.bio || (
      <>
         <p>
            Back in 2010, I started brainspin with a desire to design compelling and engaging apps. For over 7 years, I have designed many high profile web and iPhone applications. The applications range from 3D medical aided web applications to project management applications for niche industries.
         </p>
         <p className="mt-4">
            I am also the founder of a large local design organization, Salt Lake Designers, where I and other local influencers help cultivate the talents of up and coming UX designers through workshops and panel discussions.
         </p>
      </>
   );
   const instructeurAvatar = course.primary_instructor?.instructor_avatar || "/misc/verified/1.png";
   const instructorRating = course.primary_instructor?.rating || 4.5;
   const instructorReviews = course.primary_instructor?.total_reviews || 23987;
   const instructorStudents = course.primary_instructor?.total_students || 692;
   const instructorCourses = course.primary_instructor?.total_courses || 15;

   return (
      <div>
         <h2 className="text-xl font-medium text-dark-1 dark:text-white">Instructeur</h2>
         <div className="mt-6 flex flex-wrap items-center gap-6">
            <div className="w-24 h-24 overflow-hidden">
               <img className="w-full h-full object-cover" src={instructeurAvatar} alt="Instructor" />
            </div>
            <div>
               <h5 className="text-lg font-medium text-dark-1 dark:text-white">{instructorName}</h5>
               <p className="mt-1 text-gray-600 dark:text-gray-400">{instructorTitle}</p>
               <div className="mt-3 flex flex-wrap gap-4 items-center">
                  <div className="flex items-center">
                     <div className="flex items-center mr-2">
                        <FiStar className="w-4 h-4 text-yellow-400" />
                        <span className="text-sm ml-1 text-yellow-500">{instructorRating}</span>
                     </div>
                  </div>
                  <div className="flex items-center text-gray-600 dark:text-gray-400">
                     <FiMessageSquare className="w-4 h-4 mr-1" />
                     <span className="text-sm">{instructorReviews} Reviews</span>
                  </div>
                  <div className="flex items-center text-gray-600 dark:text-gray-400">
                     <FiUser className="w-4 h-4 mr-1" />
                     <span className="text-sm">{instructorStudents} Students</span>
                  </div>
                  <div className="flex items-center text-gray-600 dark:text-gray-400">
                     <FiClock className="w-4 h-4 mr-1" />
                     <span className="text-sm">{instructorCourses} Course</span>
                  </div>
               </div>
            </div>
         </div>
         <div className="mt-6 text-gray-600 dark:text-gray-300 font-sans text-[15px]">
            {instructorBio}
         </div>
      </div>
   )
}

export default Instructors